import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'kt-range-datepicker',
  templateUrl: './range-datepicker.component.html',
})
export class RangeDatepickerComponent {
  @Output() min = new EventEmitter<Date>();
  @Output() max = new EventEmitter<Date>();
  @Input('defaultMinDate') defaultMinDate;
  @Input('defaultMaxDate') defaultMaxDate;
  public minDateControl;
  public maxDateControl;
  constructor() {}

  ngOnInit() {
    this.minDateControl = new FormControl(this.defaultMinDate ? new Date(this.defaultMinDate) : null);
    this.maxDateControl = new FormControl(this.defaultMaxDate ? new Date(this.defaultMaxDate) : null);
  }
  public eventMaxDate(event: MatDatepickerInputEvent<any>) {
    this.max.emit(event.value);
  }

  public evenMinDate(event: MatDatepickerInputEvent<any>) {
    this.min.emit(event.value);
  }
}
